export default __webpack_public_path__ + "static/media/block.4e64450a.svg";